import { LambdaClient } from "@aws-sdk/client-lambda";

const lambdaClient = new LambdaClient({
  region: process.env.AWS_REGION || "ap-southeast-1",
});

export default lambdaClient;
